var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-item" }, [
    _c("div", { staticClass: "form-label" }, [
      _vm.label != null ? _c("label", [_vm._v(_vm._s(_vm.label))]) : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-value" },
      [
        _c("el-input", {
          attrs: {
            type: "number",
            disabled: _vm.disabled,
            size: "small",
            align: "right"
          },
          on: { change: _vm.syncModel },
          model: {
            value: _vm.curValue,
            callback: function($$v) {
              _vm.curValue = _vm._n($$v)
            },
            expression: "curValue"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ea0832d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea0832d4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/query/QueryNumField.vue
// module id = 2131
// module chunks = 0